<div [style.width]="deviceDetectorService.isMobile() ? '100%' : '420px'" class="p-2">
  <div class="mt-3 mb-3">
    <div class="row justify-content-between">
      <div class="col-auto">
        <div class="d-flex align-items-center">
          <span class="desktop_body_p5">
            Detalhes
          </span>
        </div>
      </div>
      <div class="col-auto">
        <button class="btn" (click)="fechar()" type="button">
          <img src="assets/imgs/icones/close-black.svg" alt="">
        </button>
      </div>
    </div>
  </div>
  <div style="height: calc(100vh - (66px + 86px)); overflow: auto">
    <mat-tab-group mat-stretch-tabs="false" mat-align-tabs="center">
      <mat-tab label="Informações">
        <div class="bg-white container-fluid">
          <div>
            <div class="d-flex align-content-center align-items-center mb-3">
              <div class="me-2" style="width: 12px; height: 12px; border-radius: 50px; background: #0d47a1"></div>
              <span class="texto-3 texto-3--color-segundario">{{parceriaService.model.titulo ?? 'Aguardando proposta'}}</span>
            </div>

            <div class="mt-3" *ngIf="parceriaService.model.propostaFeita">
              <span class="desktop_body_P1 color-texto-secundario">{{ parceriaService.model.valorProposta | currency:'BRL':'symbol':'1.2-2'}}</span>
              <p class="color-texto-secundario">/ Comissão <span class="color-sucesso">
              {{parceriaService.model.valorComissao | currency:'BRL':'symbol':'1.2-2'}}
            </span></p>
              <span class="color-vermelho-pjus">
              <strong>{{transformeData(parceriaService.model.dataVencimento)}}</strong>
            </span>
              <p class="status-info-txt">
                Os valores apresentados nesta fase são meramente
                estimativos, podendo sofrer alteração após a análise
                detalhada do processo.
              </p>
              <div class="alert alert-warning d-flex align-items-start mb-3" role="alert"
                   *ngIf="parceriaService.model.observacao">
                <img class="me-2 mt-1" src="assets/imgs/icones/info.svg" alt="">
                <div>
                  <strong class="texto-3 d-block">Observação</strong>
                  <span class="texto-3">{{ parceriaService.model.observacao }}</span>
                </div>
              </div>
              <div class="row mb-3">
                <div class="col-6" *ngIf="parceriaService.model.exibirContraproposta">
                  <button
                    (click)="fecharDrawer()"
                    [routerLink]="'/area-parceiro/cotacoes/negociar-proposta/' + (parceriaService.model.propostaId || parceriaService.idProposta)"
                    class="btn btn-outline-secondary">
                    Contraproposta
                    <img class="ms-2" src="assets/imgs/icones/cifrao.svg" alt="">
                  </button>
                </div>
                <div [ngClass]="parceriaService.model.exibirContraproposta ? 'col-6' : 'col-12'">
                  <a class="btn btn-outline-secondary link-secondary w-100" target="_blank" [href]="parceriaService.model.urlCartaProposta">
                    Baixar proposta
                    <img class="ms-2" src="assets/imgs/icones/download.svg" alt="">
                  </a>
                </div>
                <div class="col-12">
                  <button
                    (click)="fecharDrawer()"
                    [routerLink]="'/area-parceiro/cotacoes/em-negociacao/aguardando-parceiro/aceitar-proposta/' + (parceriaService.model.propostaId || parceriaService.idProposta)"
                    class="btn btn-primary mt-3 w-100">
                    Aceitar
                    <img class="ms-2" src="assets/imgs/icones/check.svg" alt="">
                  </button>
                </div>
              </div>
            </div>

            <span class="desktop_body_P11 color-texto-secundario">
            HONORÁRIOS
           </span>
            <div class="mt-3">
              <div class="mb-3">
                <app-item-texto
                  [titulo]="'Honorários Contratuais estão destacados?'"
                  [conteudo]="TipoBoolPreenchidoEnum.getName(parceriaService.model.honorariosContratuaisDestacados)"
                ></app-item-texto>
              </div>
              <div *ngIf="parceriaService.model.honorariosContratuaisDestacados === TipoBoolPreenchido.Nao" class="mb-3">
                <app-item-texto
                  [titulo]="'Qual o percentual de honorários contratuais deve ser reservado na proposta?'"
                  [conteudo]="parceriaService.model.honorarios + '%'">
                </app-item-texto>
              </div>
              <div>
                <div class="mb-3">
                  <app-item-texto
                    [titulo]="'A parcela preferencial já foi paga?'"
                    [conteudo]="parceriaService.model.parcelaPreferencialPaga === TipoBoolPreenchido.Sim ? 'Sim' : 'Não'">
                  </app-item-texto>
                </div>
                <div *ngIf="parceriaService.model.parcelaPreferencialPaga === TipoBoolPreenchido.Sim">
                  <div class="mb-3">
                    <app-item-texto
                      [titulo]="'Data do pagamento'"
                      [conteudo]="parceriaService.model.dataPgtoParcelaPreferencial | date: 'dd/MM/yyyy'">
                    </app-item-texto>
                  </div>
                  <div class="mb-3">
                    <app-item-texto
                      [titulo]="'Valor pago'"
                      [conteudo]="parceriaService.model.valorPgtoParcelaPreferencial | currency:'BRL':'symbol':'1.2-2'">
                    </app-item-texto>
                  </div>
                </div>
              </div>
              <hr>
            </div>
          </div>
          <div>
              <span class="desktop_body_P11 color-texto-secundario">
                MAIS INFORMAÇÕES
              </span>
            <div class="mt-3">
              <div class="mb-3">
                <app-item-texto
                  [titulo]="'Data base'"
                  [conteudo]="parceriaService.model.dtBase | date: 'dd/MM/yyyy'"
                ></app-item-texto>
              </div>
              <div class="mb-3">
                <app-item-texto
                  [titulo]="'Data de expedição do precatório'"
                  [conteudo]="parceriaService.model.dtExpedicao | date: 'dd/MM/yyyy'"
                ></app-item-texto>
              </div>
            </div>
          </div>
          <div class="mt-5 w-100 text-center">
            <button class="btn btn-outline-secondary w-100" type="button" (click)="cancelarProposta(parceriaService.model)">
              Cancelar cotação <img src="assets/imgs/icones/close-rounded.svg" alt="">
            </button>
          </div>
        </div>
      </mat-tab>
      <mat-tab label="Documentos ({{filtroDocumento().length}})" class="bg-white">
        <div class="bg-white">
          <div class="card p-0" *ngIf="filtroDocumento().length > 0">
            <div class="card-body p-0"
                 [style.height]="expandir && filtroDocumento().length ? 'auto' : '206px'"
                 style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">
              <table class="table table-responsive m-0 mt-2">
                <thead>
                <tr>
                  <th class="desktop_body_P7 color-texto-secundario border-bottom-0">NOME DO ARQUIVO</th>
                  <th class="desktop_body_P7 color-texto-secundario border-bottom-0">ENVIO</th>
                  <th class="desktop_body_P7 color-texto-secundario border-bottom-0">AÇÃO</th>
                </tr>
                </thead>
                <tbody>
                <tr *ngFor="let doc of filtroDocumento()">
                  <td>
                    <span class="text-truncate texto-3">{{DocumentoEnum.getName(doc.tipo)}}</span>
                    <br>
                    <small class="texto-4 texto-4--color-segundario text-uppercase">.{{doc.extensao}}</small>
                  </td>
                  <td>
                    <span class="texto-3 texto-3--color-segundario">{{doc.dataCriacao | date: 'dd/MM/yyyy'}}</span>
                  </td>
                  <td class="text-center">
                    <a [href]="doc.url" target="_blank"><img src="assets/imgs/icones/download.svg" alt=""></a>
                    <img src="assets/imgs/icones/trash-cinza.svg" alt="" (click)="deletarDocumento(doc)" class="ms-2" role="button" />
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="bg-white text-center mt-3" role="button" (click)="expandirDocumento()" *ngIf="filtroDocumento().length > 2">
          <span>
            {{ !expandir ? 'Mais documentos' : 'Menos documentos' }}
            <img [src]="'assets/imgs/icones/down.svg'" [class.rotate-180-neg]="expandir == true" alt="">
          </span>
          </div>
          <hr *ngIf="filtroDocumento().length > 0">
          <div class="bg-white">
            <span class="desktop_body_P11 color-texto-secundario">
              NOVO DOCUMENTO
            </span>
            <div class="mt-3">
              <app-envio-documentos-v2
                [propostaId]="parceriaService.model.propostaId || parceriaService.idProposta"
              ></app-envio-documentos-v2>
            </div>
          </div>
        </div>
      </mat-tab>
    </mat-tab-group>
  </div>
</div>
